class SustainabilityController {

    constructor() {

        this.setShoeneSlider();
        this.setShoeneSlider2();
        this.setShoeneSlider3();
        this.setAccordionAnimation();
    }

    setShoeneSlider() {
        if($('#js-sustainability-content__shoene-slide').length < 1) {
            return;
        }
        let options = {
            loop: true,
            loopAdditionalSlides: 1,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            loopFillGroupWithBlank: false,
            centeredSlides: false,
            spaceBetween: (window.UA.isSP) ? 0 : 0,
            slidesPerView: 1,
            touchAngle: 20,
            speed: 800,
            on: {
                activeIndexChange : function(swiper){
                    let $i = $('.sustainability-content__shoene-slide-nav-progress i');
                    let max = parseInt($('.sustainability-content__shoene-slide-nav-max').text());
                    $('.sustainability-content__shoene-slide-nav-current').text(`0${swiper.realIndex+1}`);
                    $i.css({
                        width: `${(swiper.realIndex+1)/max*100}%`
                    });

                }
            },
        };
        let shoeneSlider = new Swiper('#js-sustainability-content__shoene-slide', options);
        if (window.UA.isSP) {
            shoeneSlider.off('resize');
        }
    }
    setShoeneSlider2() {
        $('.js-shoene-slider2').each(function () {
            let $sliderContainer = $(this);
            if ($sliderContainer.length < 1) {
                return;
            }
            let options = {
                loop: true,
                loopAdditionalSlides: 1,
                loopFillGroupWithBlank: false,
                centeredSlides: false,
                spaceBetween: (window.UA.isSP) ? 10 : 10,
                slidesPerView: 1,
                touchAngle: 20,
                speed: 800,
                navigation: {
                    nextEl: '#js-shoene-slider2-next',
                    prevEl: '#js-shoene-slider2-prev',
                },
                on: {
                    activeIndexChange: function (swiper) {
                        let $progress = $sliderContainer.closest('.sustainability-content__shoene-slide').find('.sustainability-content__shoene-slide-nav-progress i');
                        let max = parseInt($sliderContainer.closest('.sustainability-content__shoene-slide').find('.sustainability-content__shoene-slide-nav-max').text());
                        $sliderContainer.closest('.sustainability-content__shoene-slide').find('.sustainability-content__shoene-slide-nav-current').text(`0${ swiper.realIndex + 1 }`);
                        $progress.css({
                            width: `${ (swiper.realIndex + 1) / max * 100 }%`
                        });
                    }
                },
            };
            let shoeneSlider = new Swiper($sliderContainer[0], options);
            if (window.UA.isSP) {
                shoeneSlider.off('resize');
            }
        });
    }
    setShoeneSlider3() {
        $('.js-shoene-slider3').each(function () {
            let $sliderContainer = $(this);
            if ($sliderContainer.length < 1) {
                return;
            }
            let options = {
                loop: true,
                loopAdditionalSlides: 1,
                loopFillGroupWithBlank: false,
                centeredSlides: false,
                spaceBetween: (window.UA.isSP) ? 10 : 10,
                slidesPerView: 1,
                touchAngle: 20,
                speed: 800,
                navigation: {
                    nextEl: '#js-shoene-slider3-next',
                    prevEl: '#js-shoene-slider3-prev',
                },
                on: {
                    activeIndexChange: function (swiper) {
                        let $progress = $sliderContainer.closest('.sustainability-content__shoene-slide').find('.sustainability-content__shoene-slide-nav-progress i');
                        let max = parseInt($sliderContainer.closest('.sustainability-content__shoene-slide').find('.sustainability-content__shoene-slide-nav-max').text());
                        $sliderContainer.closest('.sustainability-content__shoene-slide').find('.sustainability-content__shoene-slide-nav-current').text(`0${ swiper.realIndex + 1 }`);
                        $progress.css({
                            width: `${ (swiper.realIndex + 1) / max * 100 }%`
                        });
                    }
                },
            };
            let shoeneSlider = new Swiper($sliderContainer[0], options);
            if (window.UA.isSP) {
                shoeneSlider.off('resize');
            }
        });
    }
    setAccordionAnimation() {
        let details = document.querySelectorAll(".js-accordion-details");
        let RUNNING_VALUE = "running";
        let IS_OPENED_CLASS = "is-accordion-open";
        details.forEach((element) => {
            let summary = element.querySelector(".js-accordion-summary");
            let content = element.querySelector(".js-accordion-content");
            summary.addEventListener("click", (event) => {
                event.preventDefault();
                // 連打防止用。
                if (element.dataset.animStatus === RUNNING_VALUE) {
                    return;
                }
                // detailsのopen属性を判定
                if (element.open) {
                    element.classList.toggle(IS_OPENED_CLASS);
                    let closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
                    element.dataset.animStatus = RUNNING_VALUE;
                    closingAnim.onfinish = () => {
                    element.removeAttribute("open");
                    element.dataset.animStatus = "";
                    };
                } else {
                    element.setAttribute("open", "true");
                    element.classList.toggle(IS_OPENED_CLASS);
                    let openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
                    element.dataset.animStatus = RUNNING_VALUE;
                    openingAnim.onfinish = () => {
                    element.dataset.animStatus = "";
                    };
                }
            });
        });
        let animTiming = {
            duration: 250,
            easing: "ease"
        };
        let closingAnimKeyframes = (content) => [
            {
                height: content.offsetHeight + 'px',
                opacity: 1,
            }, {
                height: 0,
                opacity: 0,
            }
        ];
        let openingAnimKeyframes = (content) => [
            {
                height: 0,
                opacity: 0,
            }, {
                height: content.offsetHeight + 'px',
                opacity: 1,
            }
        ];
    }

}

export default SustainabilityController;